import ProductionTaskPage from "@/pages/ProductionTaskPage";

export default function FrosterTask() {
  return <ProductionTaskPage role="froster" design="delivery" />;
}
